import { render, staticRenderFns } from "./rolemenu.vue?vue&type=template&id=e982f11a&scoped=true"
import script from "./rolemenu.vue?vue&type=script&lang=js"
export * from "./rolemenu.vue?vue&type=script&lang=js"
import style0 from "./rolemenu.vue?vue&type=style&index=0&id=e982f11a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e982f11a",
  null
  
)

export default component.exports